/**
 * Check if the option is one of the feature flags
 * @param {Array<string>} featureFlags - list of feature flags of the user
 * @param {string} option - option to look for
 * @returns {boolean} - true if the user has the option
 */
function hasFeatureFlag(featureFlags, option) {
  return featureFlags.includes(option);
}

module.exports = hasFeatureFlag;
